(() => {
  if (window.__MF_TASSEN_COLOR_MODE__) return;
  window.__MF_TASSEN_COLOR_MODE__ = true;

  const COLORS = [
    { id:'gelb', name:'Gelb', hex:'#f2d000' },
    { id:'orange', name:'Orange', hex:'#f47a16' },
    { id:'grau', name:'Grau', hex:'#9aa0a3' },
    { id:'lila', name:'Lila', hex:'#6737a5' },
    { id:'tuerkis', name:'Türkis', hex:'#28b8bf' },
    { id:'braun', name:'Braun', hex:'#6a3b24' },
    { id:'dunkelgruen', name:'Dunkelgrün', hex:'#315a38' },
    { id:'schwarz', name:'Schwarz', hex:'#171819' },
    { id:'rot', name:'Rot', hex:'#d51f27' }
  ];

  const clamp = n => Math.max(0, Math.min(255, Math.round(n)));
  const rgb = hex => {
    const value = String(hex || '#000000').replace('#','');
    return { r:parseInt(value.slice(0,2),16)||0, g:parseInt(value.slice(2,4),16)||0, b:parseInt(value.slice(4,6),16)||0 };
  };
  const toHex = ({r,g,b}) => '#' + [r,g,b].map(v => clamp(v).toString(16).padStart(2,'0')).join('');
  const mix = (source, target, amount) => {
    const a=rgb(source), b=rgb(target), t=Math.max(0,Math.min(1,amount));
    return toHex({r:a.r+(b.r-a.r)*t,g:a.g+(b.g-a.g)*t,b:a.b+(b.b-a.b)*t});
  };

  const getHostForCanvas = canvas => {
    const root = canvas?.getRootNode?.();
    const host = root?.host;
    return host?.matches?.('[data-mf-tassen-designer-host]') ? host : null;
  };

  const originalCreateLinearGradient = CanvasRenderingContext2D.prototype.createLinearGradient;
  if (!CanvasRenderingContext2D.prototype.__mfMugColorGradientPatched) {
    Object.defineProperty(CanvasRenderingContext2D.prototype, '__mfMugColorGradientPatched', { value:true, configurable:true });
    CanvasRenderingContext2D.prototype.createLinearGradient = function(...args) {
      const gradient = originalCreateLinearGradient.apply(this,args);
      const host = getHostForCanvas(this.canvas);
      if (!host || host.dataset.mfMugMode !== 'colored') return gradient;
      const originalAddColorStop = gradient.addColorStop.bind(gradient);
      gradient.addColorStop = (offset, color) => {
        const selected = host.dataset.mfMugColorHex || COLORS[0].hex;
        const key = String(color || '').toLowerCase().replace(/\s+/g,'');
        const replacements = {
          '#c7c8c7': mix(selected,'#000000',.20),
          '#fbfbfa': mix(selected,'#ffffff',.30),
          '#d6d6d4': mix(selected,'#000000',.08),
          '#4f5151': mix(selected,'#000000',.48),
          '#aaa9a5': mix(selected,'#000000',.12),
          '#e7e5e0': mix(selected,'#ffffff',.16),
          '#f9f9f7': mix(selected,'#ffffff',.34)
        };
        originalAddColorStop(offset, replacements[key] || color);
      };
      return gradient;
    };
  }

  const activeHost = () => document.querySelector('.mf-designer-dialog[open] [data-mf-tassen-designer-host]') || document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="colored"]');

  const setColor = (host, id, notify = true) => {
    if (!host) return;
    const selected = COLORS.find(c => c.id === id) || COLORS[0];
    host.dataset.mfMugMode='colored';
    host.dataset.mfMugColor=selected.name;
    host.dataset.mfMugColorId=selected.id;
    host.dataset.mfMugColorHex=selected.hex;
    try { localStorage.setItem('mf-tassenfarbe-330ml',selected.id); } catch(_) {}

    const root=host.shadowRoot;
    root?.querySelectorAll('[data-mf-mug-color]').forEach(button => {
      const on=button.dataset.mfMugColor===selected.id;
      button.classList.toggle('is-active',on);
      button.setAttribute('aria-pressed',on?'true':'false');
    });
    const label=root?.querySelector('[data-mf-mug-color-label]');
    if(label && label.textContent!==selected.name) label.textContent=selected.name;
    const summary=root?.querySelector('.summary-box strong');
    if(summary && summary.textContent!==`Fototasse · ${selected.name}`) summary.textContent=`Fototasse · ${selected.name}`;
    root?.querySelectorAll('.cart-line strong').forEach(el=>{const value=`Fototasse · ${selected.name}`;if(el.textContent!==value)el.textContent=value;});
    if(notify) host.dispatchEvent(new CustomEvent('mf:mug-color-change',{detail:selected}));
  };

  const patchCopy = host => {
    const root=host?.shadowRoot;
    if(!root)return;
    const intro=root.querySelector('.intro h1');
    if(intro && /weiße tasse/i.test(intro.textContent||'')) intro.innerHTML='Deine Tasse.<br><em>Rundum gestaltet.</em>';
    const tip=root.querySelector('.tip-box');
    if(tip){
      const spans=tip.querySelectorAll('span');
      if(spans[0]&&spans[0].textContent!=='1. Tassenfarbe auswählen')spans[0].textContent='1. Tassenfarbe auswählen';
      if(spans[1]&&spans[1].textContent!=='2. Foto und Text einfügen & ausrichten')spans[1].textContent='2. Foto und Text einfügen & ausrichten';
      if(spans[2]&&spans[2].textContent!=='3. Tasse drehen & Vorschau prüfen')spans[2].textContent='3. Tasse drehen & Vorschau prüfen';
    }
  };

  const ensureColorUI = host => {
    const root=host?.shadowRoot;
    if(!root)return false;
    const controls=root.querySelector('.controls-card');
    if(!controls)return false;
    patchCopy(host);

    if(!root.querySelector('.mf-mug-color-section')){
      const section=document.createElement('div');
      section.className='control-section mf-mug-color-section';
      section.innerHTML=`<div class="control-label"><span>1</span><strong>Tassenfarbe</strong></div><div class="mf-mug-color-head"><small>Henkel &amp; Innenbereich</small><b data-mf-mug-color-label></b></div><div class="mf-mug-color-grid" role="group" aria-label="Tassenfarbe wählen">${COLORS.map(c=>`<button type="button" data-mf-mug-color="${c.id}" aria-pressed="false" title="${c.name}"><i style="--mf-mug-swatch:${c.hex}"></i><span>${c.name}</span></button>`).join('')}</div>`;
      const firstSection=controls.querySelector('.control-section');
      if(firstSection) controls.insertBefore(section,firstSection); else controls.appendChild(section);
      section.querySelectorAll('[data-mf-mug-color]').forEach(button=>button.addEventListener('click',()=>setColor(host,button.dataset.mfMugColor)));
      const sections=[...controls.querySelectorAll('.control-section')].filter(el=>!el.classList.contains('mf-mug-color-section'));
      sections.forEach((el,index)=>{const number=el.querySelector('.control-label > span');if(number&&index<2)number.textContent=String(index+2);});
    }

    let saved='gelb';
    try { saved=localStorage.getItem('mf-tassenfarbe-330ml') || 'gelb'; } catch(_) {}
    setColor(host,host.dataset.mfMugColorId||saved,false);

    if(!root.querySelector('#mf-mug-color-style')){
      const style=document.createElement('style');
      style.id='mf-mug-color-style';
      style.textContent=`.mf-mug-color-section{border-top:0!important;padding-top:0!important}.mf-mug-color-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:-2px 0 10px;color:#aaa}.mf-mug-color-head small{font-size:11px}.mf-mug-color-head b{color:#f58220;font-size:12px}.mf-mug-color-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}.mf-mug-color-grid button{min-width:0;display:grid;grid-template-columns:24px minmax(0,1fr);align-items:center;gap:7px;padding:8px;border:1px solid rgba(255,255,255,.16);border-radius:8px;background:#232426;color:#eee;cursor:pointer}.mf-mug-color-grid button:hover{border-color:rgba(245,130,32,.65)}.mf-mug-color-grid button.is-active{border-color:#f58220;box-shadow:0 0 0 1px #f58220;background:rgba(245,130,32,.12)}.mf-mug-color-grid button i{display:block;width:24px;height:24px;border-radius:50%;background:var(--mf-mug-swatch);border:1px solid rgba(255,255,255,.5);box-shadow:inset 0 1px 2px rgba(255,255,255,.25)}.mf-mug-color-grid button span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:10px;font-weight:700;text-align:left}@media(max-width:749px){.mf-mug-color-grid{grid-template-columns:repeat(3,minmax(0,1fr))}.mf-mug-color-grid button{grid-template-columns:20px minmax(0,1fr);padding:7px 6px}.mf-mug-color-grid button i{width:20px;height:20px}.mf-mug-color-grid button span{font-size:9px}}`;
      root.appendChild(style);
    }
    return true;
  };

  const watchHost = host => {
    if(!host || host.dataset.mfMugColorWatch==='1')return;
    host.dataset.mfMugMode='colored';
    host.dataset.mfMugColorWatch='1';
    let tries=0;
    const tick=()=>{
      tries++;
      const ready=ensureColorUI(host);
      if(ready && host.shadowRoot && !host.__mfMugColorShadowObserver){
        const shadowObserver=new MutationObserver(()=>ensureColorUI(host));
        shadowObserver.observe(host.shadowRoot,{childList:true,subtree:true});
        host.__mfMugColorShadowObserver=shadowObserver;
      }
      if(!ready && tries<80)setTimeout(tick,100);
    };
    tick();
    const observer=new MutationObserver(()=>tick());
    observer.observe(host,{childList:true,subtree:true});
  };

  const boot=()=>document.querySelectorAll('[data-mf-tassen-designer-host][data-mf-mug-mode="colored"]').forEach(watchHost);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();

  const previousFetch=window.fetch.bind(window);
  window.fetch=async function mfTassenColorFetch(input,init={}){
    try{
      const url=typeof input==='string'?input:String(input?.url||'');
      const method=String(init?.method||'GET').toUpperCase();
      const body=init?.body;
      if(method==='POST' && /\/cart\/add\.js(?:\?|$)/.test(url) && body instanceof FormData){
        const host=activeHost();
        if(host?.dataset?.mfMugMode==='colored'){
          const color=String(host.dataset.mfMugColor||'').trim();
          if(color && !body.has('properties[Tassenfarbe]'))body.append('properties[Tassenfarbe]',color);
          if(host.dataset.mfMugColorId && !body.has('properties[_MF Tassenfarbe-ID]'))body.append('properties[_MF Tassenfarbe-ID]',host.dataset.mfMugColorId);
        }
      }
    }catch(error){console.warn('[MF Tassenfarbe]',error)}
    return previousFetch(input,init);
  };
})();